import React, { useState } from 'react';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import SitewebForm from './SitewebForm';
import SitewebReportsList from './SitewebReportsList';

function DeploiementsSitewebPage() {
  const [ongletActif, setOngletActif] = useState(0);
  const [rafraichirDeclencheur, setRafraichirDeclencheur] = useState(0);
  const isMobile = window.innerHeight > window.innerWidth;

  return (
    <Container maxWidth={false} className={isMobile ? 'conteneur-accueil-mobile' : 'conteneur-accueil'}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className="rounded-lg bg-primary" style={{ padding: 16 }}>
            <Typography className="text-primary" variant="h4">Ingenierie - Deploiement siteweb</Typography>
            <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
              Procedure guidee pour `scriptTransfert.sh` avec controles prealables, execution et validation post-deploiement.
            </Typography>
            <Tabs value={ongletActif} onChange={(event, valeur) => setOngletActif(valeur)} indicatorColor="primary" textColor="primary" style={{ marginTop: 16 }}>
              <Tab label="Nouveau deploiement siteweb" />
              <Tab label="Historique rapports siteweb" />
            </Tabs>
          </Paper>
        </Grid>

        {ongletActif === 0 && (
          <Grid item xs={12}>
            <SitewebForm onCreation={() => {
              setRafraichirDeclencheur((p) => p + 1);
              setOngletActif(1);
            }} />
          </Grid>
        )}

        {ongletActif === 1 && (
          <Grid item xs={12}>
            <SitewebReportsList rafraichirDeclencheur={rafraichirDeclencheur} />
          </Grid>
        )}
      </Grid>
    </Container>
  );
}

export default DeploiementsSitewebPage;



// WEBPACK FOOTER //
// src/components/deploiementsSiteweb/DeploiementsSitewebPage.js